import plant from "@icons/vegetables/plant.svg";

import vegetables from "@icons/types/vegetables.png";

// Fruits and vegetables pack
// import tomato from "@icons/vegetables/fruits-and-vegetables/lineal color/003-tomato.svg";
// import cucumber from
// '@icons/vegetables/fruits-and-vegetables/lineal color/004-cucumber.svg';
// import cabbage from "@icons/vegetables/fruits-and-vegetables/lineal color/005-cabbage.svg";
// import radish from '@icons/vegetables/fruits-and-vegetables/lineal color/006-radish.svg';
// import eggplant from "@icons/vegetables/fruits-and-vegetables/lineal color/007-eggplant.svg";
import potiron from "@icons/vegetables/fruits-and-vegetables/lineal color/008-pumpkin.svg";
// import bellPepper from "@icons/vegetables/fruits-and-vegetables/lineal color/009-bell-pepper.svg";
// import onion from '@icons/vegetables/fruits-and-vegetables/lineal color/010-garlic.svg';
// import corn from "@icons/vegetables/fruits-and-vegetables/lineal color/011-corn.svg";
// import potato from "@icons/vegetables/fruits-and-vegetables/lineal color/013-potato.svg";
// import banana from "@icons/vegetables/fruits-and-vegetables/lineal color/014-banana.svg";
// import raspberries from "@icons/vegetables/fruits-and-vegetables/lineal color/020-raspberry.svg";
import apricot from "@icons/vegetables/fruits-and-vegetables/lineal color/023-apricot.svg";
// import broccoli from "@icons/vegetables/fruits-and-vegetables/lineal color/025-broccoli.svg";
import cauliflower from "@icons/vegetables/fruits-and-vegetables/lineal color/027-cauliflower.svg";
// import garlic from "@icons/vegetables/fruits-and-vegetables/lineal color/029-garlic-1.svg";
// import spinach from "@icons/vegetables/fruits-and-vegetables/lineal color/030-spinach.svg";
// import asparagus from "@icons/vegetables/fruits-and-vegetables/lineal color/031-asparagus.svg";
// import chiliPepper from "@icons/vegetables/fruits-and-vegetables/lineal color/032-chili-pepper.svg";
import peas from "@icons/vegetables/fruits-and-vegetables/lineal color/033-peas.svg";
// import carrot from "@icons/vegetables/fruits-and-vegetables/lineal color/035-carrot.svg";
// import beet from "@icons/vegetables/fruits-and-vegetables/lineal color/037-beet.svg";
// import zucchini from "@icons/vegetables/fruits-and-vegetables/lineal color/038-zucchini.svg";
// import celery from "@icons/vegetables/fruits-and-vegetables/lineal color/039-celery.svg";
import sweetPotato from "@icons/vegetables/fruits-and-vegetables/lineal color/047-sweet-potato.svg";
import brusselsSprouts from "@icons/vegetables/fruits-and-vegetables/lineal color/048-brussels-sprouts.svg";
import patisson from "@icons/vegetables/fruits-and-vegetables/lineal color/049-pumpkin-1.svg";
// import arugula from "@icons/vegetables/fruits-and-vegetables/lineal color/051-arugula.svg";
import dill from "@icons/vegetables/fruits-and-vegetables/lineal color/052-dill.svg";
// import parsley from "@icons/vegetables/fruits-and-vegetables/lineal color/053-parsley.svg";
import kohlrabi from "@icons/vegetables/fruits-and-vegetables/lineal color/057-kohlrabi.svg";
import butternut from "@icons/vegetables/fruits-and-vegetables/lineal color/058-squash.svg";
// import leek from "@icons/vegetables/fruits-and-vegetables/lineal color/074-leek.svg";
// import rhubarb from "@icons/vegetables/fruits-and-vegetables/lineal color/075-rhubarb.svg";
import horseradish from "@icons/vegetables/fruits-and-vegetables/lineal color/077-horseradish.svg";
// import turnip from "@icons/vegetables/fruits-and-vegetables/lineal color/079-radish-1.svg";

// Fruit and vegetable pack
import agave from "@icons/vegetables/fruit-and-vegetable/agave.png";
import almond from "@icons/vegetables/fruit-and-vegetable/almond.png";
import aloeVera from "@icons/vegetables/fruit-and-vegetable/aloe-vera.png";
import apple from "@icons/vegetables/fruit-and-vegetable/apple.png";
import artichoke from "@icons/vegetables/fruit-and-vegetable/artichoke.png";
import asparagus from "@icons/vegetables/fruit-and-vegetable/asparagus.png";
import avocado from "@icons/vegetables/fruit-and-vegetable/avocado.png";
import bamboo from "@icons/vegetables/fruit-and-vegetable/bamboo.png";
// import banana from "@icons/vegetables/fruit-and-vegetable/banana.png";
// import basil from "@icons/vegetables/fruit-and-vegetable/basil.png";
// import beans from "@icons/vegetables/fruit-and-vegetable/beans.png";
import beet from "@icons/vegetables/fruit-and-vegetable/beet.png";
import elderberry from "@icons/vegetables/fruit-and-vegetable/berries.png";
import broccoli from "@icons/vegetables/fruit-and-vegetable/broccoli.png";
import cabbage from "@icons/vegetables/fruit-and-vegetable/cabbage.png";
import cacao from "@icons/vegetables/fruit-and-vegetable/cacao.png";
import cactus from "@icons/vegetables/fruit-and-vegetable/cactus.png";
import carrot from "@icons/vegetables/fruit-and-vegetable/carrot.png";
// import cauliflower from "@icons/vegetables/fruit-and-vegetable/cauliflower.png";
import celeryRave from "@icons/vegetables/fruit-and-vegetable/celery-rave.png";
import celery from "@icons/vegetables/fruit-and-vegetable/celery.png";
import chard from "@icons/vegetables/fruit-and-vegetable/chard.png";
// import cherry from "@icons/vegetables/fruit-and-vegetable/cherry.png";
import chiliPepper from "@icons/vegetables/fruit-and-vegetable/chili-pepper.png";
import cinnamon from "@icons/vegetables/fruit-and-vegetable/cinnamon.png";
import clove from "@icons/vegetables/fruit-and-vegetable/clove.png";
import coconut from "@icons/vegetables/fruit-and-vegetable/coconut.png";
import coffee from "@icons/vegetables/fruit-and-vegetable/coffee.png";
import corn from "@icons/vegetables/fruit-and-vegetable/corn.png";
import cotton from "@icons/vegetables/fruit-and-vegetable/cotton.png";
import coulemelle from "@icons/vegetables/fruit-and-vegetable/coulemelle.png";
import cornichon from "@icons/vegetables/fruit-and-vegetable/cucumber.png";
import custardApple from "@icons/vegetables/fruit-and-vegetable/custard-appel.png";
import datePalm from "@icons/vegetables/fruit-and-vegetable/date-palm.png";
import dragonFruit from "@icons/vegetables/fruit-and-vegetable/dragon-fruit.png";
import durian from "@icons/vegetables/fruit-and-vegetable/durian.png";
import eggplants from "@icons/vegetables/fruit-and-vegetable/eggplants.png";
import fennel from "@icons/vegetables/fruit-and-vegetable/fennel.png";
import ficus from "@icons/vegetables/fruit-and-vegetable/ficus.png";
import garlic from "@icons/vegetables/fruit-and-vegetable/garlic.png";
import ginger from "@icons/vegetables/fruit-and-vegetable/ginger.png";
import goji from "@icons/vegetables/fruit-and-vegetable/goji.png";
import grape from "@icons/vegetables/fruit-and-vegetable/grape.png";
// import x from "@icons/vegetables/fruit-and-vegetable/herb.png";
import kiwi from "@icons/vegetables/fruit-and-vegetable/kiwi.png";
import leek from "@icons/vegetables/fruit-and-vegetable/leek.png";
import lemon from "@icons/vegetables/fruit-and-vegetable/lemon.png";
import lettuceChinese from "@icons/vegetables/fruit-and-vegetable/lettuce.png";
import lime from "@icons/vegetables/fruit-and-vegetable/lime.png";
import lychee from "@icons/vegetables/fruit-and-vegetable/lychee.png";
import mango from "@icons/vegetables/fruit-and-vegetable/mango.png";
import mongosteen from "@icons/vegetables/fruit-and-vegetable/mangosteen.png";
// import melon from "@icons/vegetables/fruit-and-vegetable/melon.png";
// import mushroom from "@icons/vegetables/fruit-and-vegetable/mushroom.png";
// import mushrooms from "@icons/vegetables/fruit-and-vegetable/mushrooms.png";
import olive from "@icons/vegetables/fruit-and-vegetable/olive.png";
import onion from "@icons/vegetables/fruit-and-vegetable/onion.png";
import orange from "@icons/vegetables/fruit-and-vegetable/orange.png";
import papaya from "@icons/vegetables/fruit-and-vegetable/papaya.png";
import passionFruit from "@icons/vegetables/fruit-and-vegetable/passion-fruit.png";
import peach from "@icons/vegetables/fruit-and-vegetable/peach.png";
import peanut from "@icons/vegetables/fruit-and-vegetable/peanut.png";
import pear from "@icons/vegetables/fruit-and-vegetable/pear.png";
// import pecan from "@icons/vegetables/fruit-and-vegetable/pecan.png";
// import pepper from "@icons/vegetables/fruit-and-vegetable/pepper.png";
import physalis from "@icons/vegetables/fruit-and-vegetable/physalis.png";
import pineapple from "@icons/vegetables/fruit-and-vegetable/pineapple.png";
import poivron from "@icons/vegetables/fruit-and-vegetable/poivron.png";
import pomegranate from "@icons/vegetables/fruit-and-vegetable/pomegranate.png";
import potatos from "@icons/vegetables/fruit-and-vegetable/potatos.png";
import pumpkin from "@icons/vegetables/fruit-and-vegetable/pumpkin.png";
import quince from "@icons/vegetables/fruit-and-vegetable/quince.png";
import daikon from "@icons/vegetables/fruit-and-vegetable/radish.png";
// import raspberry from "@icons/vegetables/fruit-and-vegetable/raspberry.png";
import redCabbage from "@icons/vegetables/fruit-and-vegetable/red-cabbage.png";
import roseApple from "@icons/vegetables/fruit-and-vegetable/rose-apple.png";
import rubber from "@icons/vegetables/fruit-and-vegetable/rubber.png";
import shallot from "@icons/vegetables/fruit-and-vegetable/shallot.png";
// import x from "@icons/vegetables/fruit-and-vegetable/shiitake.png";
import soybean from "@icons/vegetables/fruit-and-vegetable/soybean.png";
import spinach from "@icons/vegetables/fruit-and-vegetable/spinach.png";
import starfruit from "@icons/vegetables/fruit-and-vegetable/starfruit.png";
import strawberry from "@icons/vegetables/fruit-and-vegetable/strawberry.png";
import sugarCane from "@icons/vegetables/fruit-and-vegetable/sugar-cane.png";
import sunflower from "@icons/vegetables/fruit-and-vegetable/sunflower.png";
import wildStrawberry from "@icons/vegetables/wild_strawberry.png";
// import sweetPotato from "@icons/vegetables/fruit-and-vegetable/sweet-potato.png";
import tamarind from "@icons/vegetables/fruit-and-vegetable/tamarind.png";
import tomato from "@icons/vegetables/fruit-and-vegetable/tomato.png";
import turnip from "@icons/vegetables/fruit-and-vegetable/turnip.png";
// import x from "@icons/vegetables/fruit-and-vegetable/vegetable.png";
// import walnut from "@icons/vegetables/fruit-and-vegetable/walnut.png";
import wasabi from "@icons/vegetables/fruit-and-vegetable/wasabi.png";
import watermelon from "@icons/vegetables/fruit-and-vegetable/watermelon.png";
import weed from "@icons/vegetables/fruit-and-vegetable/weed.png";
import wheat from "@icons/vegetables/fruit-and-vegetable/wheat.png";
import white from "@icons/vegetables/fruit-and-vegetable/white.png";
import zucchini from "@icons/vegetables/fruit-and-vegetable/zucchini.png";

// Herbs and spices pack
import anis from "@icons/vegetables/herbs-and-spices/anise.png";
import arugula from "@icons/vegetables/herbs-and-spices/arugula.png";
// import x from "@icons/vegetables/herbs-and-spices/barberry.png";
import basil from "@icons/vegetables/herbs-and-spices/basil.png";
import bay from "@icons/vegetables/herbs-and-spices/bay.png";
import cardamom from "@icons/vegetables/herbs-and-spices/cardamom.png";
// import chilli from "@icons/vegetables/herbs-and-spices/chilli.png";
import chives from "@icons/vegetables/herbs-and-spices/chives.png";
// import cinnamon from "@icons/vegetables/herbs-and-spices/cinnamon.png";
// import clove from "@icons/vegetables/herbs-and-spices/clove.png";
import coriander from "@icons/vegetables/herbs-and-spices/coriander.png";
import cumin from "@icons/vegetables/herbs-and-spices/cumin.png";
// import dill from "@icons/vegetables/herbs-and-spices/dill.png";
// import fennel from "@icons/vegetables/herbs-and-spices/fennel.png";
import pinkGarlic from "@icons/vegetables/herbs-and-spices/garlic.png";
// import ginger from "@icons/vegetables/herbs-and-spices/ginger.png";
import greenOnion from "@icons/vegetables/herbs-and-spices/green-onion.png";
// import juniper from "@icons/vegetables/herbs-and-spices/juniper.png";
import lemonGrass from "@icons/vegetables/herbs-and-spices/lemon.png";
import mint from "@icons/vegetables/herbs-and-spices/mint.png";
import mustard from "@icons/vegetables/herbs-and-spices/mustard.png";
import nutmeg from "@icons/vegetables/herbs-and-spices/nutmeg.png";
// import olives from "@icons/vegetables/herbs-and-spices/olives.png";
import redOnion from "@icons/vegetables/herbs-and-spices/onion.png";
import oregano from "@icons/vegetables/herbs-and-spices/oregano.png";
// import paprika from "@icons/vegetables/herbs-and-spices/paprika.png";
import parsley from "@icons/vegetables/herbs-and-spices/parsley.png";
// import x from "@icons/vegetables/herbs-and-spices/pepper tree.png";
// import x from "@icons/vegetables/herbs-and-spices/pepper.png";
import poppy from "@icons/vegetables/herbs-and-spices/poppy.png";
import rosehip from "@icons/vegetables/herbs-and-spices/rosehip.png";
import rosemary from "@icons/vegetables/herbs-and-spices/rosemary.png";
import saffron from "@icons/vegetables/herbs-and-spices/saffron.png";
import savory from "@icons/vegetables/herbs-and-spices/savory.png";
import sesame from "@icons/vegetables/herbs-and-spices/sesame.png";
// import x from "@icons/vegetables/herbs-and-spices/tamarind.png";
import tarragon from "@icons/vegetables/herbs-and-spices/tarragon.png";
import thyme from "@icons/vegetables/herbs-and-spices/thyme.png";
import turmeric from "@icons/vegetables/herbs-and-spices/turmeric.png";
import vanilla from "@icons/vegetables/herbs-and-spices/vanilla.png";

// Herb pack
import chamomile from "@icons/vegetables/herb/lineal color/007-chamomile.svg";
import cornflower from "@icons/vegetables/herb/lineal color/008-herb.svg";
import cress from "@icons/vegetables/herb/lineal color/013-cress.svg";

// Salad pack
import squash from "@icons/vegetables/salad/lineal color/033-squash.svg";

// Vegan pack
import bananas from "@icons/vegetables/vegan/lineal color/004-bananas.svg";

// Berries pack
import barberry from "@icons/vegetables/berries/barberry.png";
import blackberry from "@icons/vegetables/berries/blackberry.png";
import blackcurrant from "@icons/vegetables/berries/blackcurrant.png";
import blueberry from "@icons/vegetables/berries/blueberry.png";
import cherries from "@icons/vegetables/berries/cherries.png";
import cherry from "@icons/vegetables/berries/cherry.png";
import cloudberry from "@icons/vegetables/berries/cloudberry.png";
import cranberry from "@icons/vegetables/berries/cranberry.png";
import currant from "@icons/vegetables/berries/currant.png";
// import dogRose from "@icons/vegetables/berries/dog-rose.png";
import gooseberry from "@icons/vegetables/berries/gooseberry.png";
import juniper from "@icons/vegetables/berries/juniper.png";
import lingonberry from "@icons/vegetables/berries/lingonberry.png";
import raspberry from "@icons/vegetables/berries/raspberry.png";
import rowan from "@icons/vegetables/berries/rowan.png";
import viburnum from "@icons/vegetables/berries/viburnum.png";

// Nuts pack
import chickpeas from "@icons/vegetables/nuts/chickpeas.png";
import hazelnut from "@icons/vegetables/nuts/hazelnut.png";
import pecan from "@icons/vegetables/nuts/pecan.png";
import walnut from "@icons/vegetables/nuts/walnut.png";

// Single icons
import blackRadish from "@icons/good_ware/black-radish.png";
import radish from "@icons/vegetables/radish.svg";
import flower from "@icons/vegetables/sunflower.svg";
// import springOnion from "@icons/vegetables/spring-onion.svg";
import barley from "@icons/vegetables/barley.svg";
import petsai from "@icons/vegetables/cabbage.svg";
import cucumber from "@icons/vegetables/cucumber.svg";
import fava from "@icons/vegetables/fava.png";
import greenBean from "@icons/vegetables/green-beans.png";
import lavender from "@icons/vegetables/lavender.svg";
import melon from "@icons/vegetables/melon.svg";
import olives from "@icons/vegetables/olives.svg";
import angiosperm from "@icons/vegetables/peach.png";
// import grape from "@icons/vegetables/grape.png";
import ginkgo from "@icons/bsd/ginkgo.png";
import chlorophyll from "@icons/eucalyp/chlorophyll.png";
import romaineLettuce from "@icons/eucalyp/romaine-lettuce.png";
import coreopsis from "@icons/icongeek26/coreopsis.png";
import pod from "@icons/juicy_fish/pod.png";
import chlorellaVulgaris from "@icons/magnific/chlorella-vulgaris.png";
import sorrel from "@icons/magnific/sorrel.png";
import spruce from "@icons/magnific/spruce.png";
import algae from "@icons/slamlabs/algae.png";
import cone from "@icons/slamlabs/cone.png";
import dicotyledon from "@icons/slamlabs/dicotyledon.png";
import fern from "@icons/slamlabs/fern.png";
import moss from "@icons/slamlabs/moss.png";
import seed from "@icons/smashicons/seed.png";
import kiwano from "@icons/umeicon/kiwano.png";
import spore from "@icons/vectors_tank/spore.png";
import acornSquash from "@icons/vegetables/acorn-squash.png";
import belgianEndive from "@icons/vegetables/belgian-endive.png";
import bokChoy from "@icons/vegetables/bok-choy.png";
import chayote from "@icons/vegetables/chayote.png";
import chestnut from "@icons/vegetables/chestnut.png";
import chicory from "@icons/vegetables/chicory.png";
import dandelion from "@icons/vegetables/dandelion.png";
import flax from "@icons/vegetables/flax.png";
import grass from "@icons/vegetables/grass.png";
import lentils from "@icons/vegetables/lentils.png";
import lettuce from "@icons/vegetables/lettuce.png";
import mache from "@icons/vegetables/mache.svg";
import oat from "@icons/vegetables/oat.png";
import parsnip from "@icons/vegetables/parsnip.png";
import redcurrant from "@icons/vegetables/redcurrant.png";
import reeds from "@icons/vegetables/reeds.png";
import rhubarb from "@icons/vegetables/rhubarb.png";
import romanesco from "@icons/vegetables/romanesco-broccoli.png";
import thisle from "@icons/vegetables/thistle.png";

// Agriculture pack
import seedingGreenhouse from "@icons/agriculture/013-greenhouse.svg";
import seedingSprout from "@icons/agriculture/014-sprout.svg";
import seeding from "@icons/agriculture/015-planting.svg";
// import seeds from '@icons/agriculture/038-seeds.svg';
import shovel from "@icons/agriculture/004-shovel.svg";
import buyPlant from "@icons/agriculture/023-plant-1.svg";
import plant2 from "@icons/agriculture/044-plant.svg";

// Vegetable types
import leaf from "@icons/leaf.png";

// Menu icons
import farmerFemale from "@icons/farmer-female.png";
import vegetableGarden from "@icons/vegetable-garden.png";
import actionPlan from "@icons/juicy_fish/action-plan.png";
import blueprint from "@icons/juicy_fish/blueprint.png";
import checkMark from "@icons/juicy_fish/check-mark.png";
import daylightSavingTime from "@icons/juicy_fish/daylight-saving-time.png";
import deadline from "@icons/juicy_fish/deadline.png";
import dna from "@icons/juicy_fish/dna.png";
import farmerMale from "@icons/juicy_fish/farmer.png";
import growPlant from "@icons/juicy_fish/grow-plant.png";
import humidity from "@icons/juicy_fish/humidity.png";
import magicWand from "@icons/juicy_fish/magic-wand.png";
import puzzle from "@icons/juicy_fish/puzzle.png";
import seedBag from "@icons/juicy_fish/seed-bag.png";
import shoppingCart from "@icons/juicy_fish/shopping-cart.png";
import flyingMoney from "@icons/cuputo/flying-money.png";
import springCalendar from "@icons/juicy_fish/spring-calendar.png";
import sunrise from "@icons/juicy_fish/sunrise.png";
import sunshine from "@icons/juicy_fish/sunshine.png";
import waterDrop from "@icons/juicy_fish/water-drop.png";
import sprinkler from "@icons/sprinkler.png";
import wheelbarrow from "@icons/juicy_fish/wheelbarrow.png";
import wind from "@icons/juicy_fish/wind.png";
import sufficiency from "@icons/sufficiency.png";

// Weather condition icons, keyed by the OWM icon code's 2-digit prefix (day/night
// agnostic — "01d"/"01n" both resolve via "01").
import weatherSun from "@icons/weather/sun.png";
import weatherSunCloud from "@icons/weather/sun_cloud.png";
import weatherCloud from "@icons/weather/cloud.png";
import weatherDarkCloud from "@icons/weather/dark_cloud.png";
import weatherRain from "@icons/weather/rain.png";
import weatherRainyDay from "@icons/weather/rainy-day.png";
import weatherThunderstorm from "@icons/weather/thunderstorm.png";
import weatherSnowfall from "@icons/weather/snowfall.png";

// Garden plan
import footprint from "@icons/footprint.png";
import grassPlan from "@icons/grass.png";
import trunk from "@icons/trunk.png";
import crate from "@icons/juicy_fish/crate.png";
import cross from "@icons/juicy_fish/cross.png";
import greenhouse from "@icons/juicy_fish/greenhouse.png";
import hedge from "@icons/juicy_fish/hedge.png";
import home from "@icons/juicy_fish/home.png";
import pitchfork from "@icons/juicy_fish/pitchfork.png";
import raindrops from "@icons/juicy_fish/raindrops.png";
import tree from "@icons/juicy_fish/tree.png";

export const TAXON_ICONS: Record<string, string> = {
  abricotier: apricot,
  agave,
  ail: garlic,
  "ail blanc": garlic,
  "ail rose": pinkGarlic,
  "airelle rouge": lingonberry,
  "aloe vera": aloeVera,
  amandier: almond,
  ananas: pineapple,
  aneth: dill,
  angiosperme: angiosperm,
  "anis vert": anis,
  arachide: peanut,
  artichaut: artichoke,
  asperge: asparagus,
  attier: custardApple,
  aubergine: eggplants,
  avocatier: avocado,
  avoine: oat,
  "baie de goji": goji,
  bambou: bamboo,
  bananier: bananas,
  basilic: basil,
  berberis: barberry,
  bette: chard,
  betterave: beet,
  bigarreau: cherries,
  ble: wheat,
  "ble tendre": wheat,
  bleuet: cornflower,
  brocoli: broccoli,
  butternut,
  cacao,
  cactus,
  cafe: coffee,
  cafier: coffee,
  "cafeier d'arabie": coffee,
  camomille: chamomile,
  "canne a sucre": sugarCane,
  canneberge: cranberry,
  cannelle: cinnamon,
  cannelier: cinnamon,
  caoutchouc: rubber,
  carambolier: starfruit,
  cardamome: cardamom,
  cardon: thisle,
  carotte: carrot,
  cassis: blackcurrant,
  "celeri-branche": celery,
  "celeri-rave": celeryRave,
  chanvre: weed,
  charophyte: algae,
  chataignier: chestnut,
  chayote,
  chicoree: chicory,
  chlorobionte: chlorophyll,
  chlorophyte: chlorellaVulgaris,
  chou: cabbage,
  "chou cabus": cabbage,
  "chou de bruxelles": brusselsSprouts,
  "chou-fleur": cauliflower,
  "chou-rave": kohlrabi,
  "chou chinois (pak choi)": bokChoy,
  "chou romanesco": romanesco,
  "chou rouge": redCabbage,
  ciboulette: chives,
  ciboule: greenOnion,
  citron: lemon,
  citronnier: lemon,
  "citron vert": lime,
  citronnelle: lemonGrass,
  citrouille: pumpkin,
  "clou de girofle": clove,
  cocotier: coconut,
  "coeur de boeuf": tomato,
  cognassier: quince,
  concombre: cucumber,
  conifere: spruce,
  "coqueret du perou": physalis,
  "coqueret pubescent": physalis,
  coreopsis,
  "coreopsis des teinturiers": coreopsis,
  coriandre: coriander,
  cornichon,
  coton: cotton,
  "coton mexicain": cotton,
  coulemelle,
  courge: pumpkin,
  "courge musquee": pumpkin,
  "courge turbinee": acornSquash,
  courgette: zucchini,
  "cresson alenois": cress,
  "cresson de fontaine": cress,
  "cresson de jardin": cress,
  "crocus a safran": saffron,
  curcuma: turmeric,
  cumin,
  daikon,
  dattier: datePalm,
  dicotyledone: dicotyledon,
  durian,
  echalote: shallot,
  eglantier: rosehip,
  endive: belgianEndive,
  epinard: spinach,
  estragon: tarragon,
  fenouil: fennel,
  feve: fava,
  figuier: ficus,
  fougere: fern,
  "fraisier des bois": wildStrawberry,
  fraisier: strawberry,
  framboisier: raspberry,
  genevrier: juniper,
  gingembre: ginger,
  ginkgo,
  giroflier: clove,
  goji,
  graminee: grass,
  grenade: pomegranate,
  grenadier: pomegranate,
  grenadille: passionFruit,
  griotte: cherry,
  "groseille a maquereau": gooseberry,
  "groseillier a grappes": redcurrant,
  gymnosperme: cone,
  haricot: greenBean,
  "haricot a rames": greenBean,
  "haricot nain": greenBean,
  jamrosat: roseApple,
  kiwai: kiwi,
  kiwano,
  kiwi,
  laitue: lettuce,
  "laitue romaine": romaineLettuce,
  "laitue chinoise": lettuceChinese, // Not really
  "laurier-sauce": bay,
  lavande: lavender,
  "lavande officinale": lavender,
  legumineuse: pod,
  lentille: lentils,
  limettier: lime,
  lin: flax,
  litchi: lychee,
  "lyciet commun": goji,
  mache, // icône maison (rosette de feuilles), src/assets/icons-128/vegetables/mache.svg
  mais: corn,
  mangier: mango,
  mangoustanier: mongosteen,
  melon,
  menthe: mint,
  merisier: cherry,
  monilophyte: spore,
  monocotyledone: grass,
  mousse: moss,
  moutarde: mustard,
  muscadier: nutmeg,
  myrtille: blueberry,
  navet: turnip,
  "noire de crimee": tomato,
  noisetier: hazelnut,
  "noix de coco": coconut,
  noyer: walnut,
  oignon: onion,
  olive,
  olivier: olive,
  "oignon blanc": greenOnion,
  "oignon rouge": redOnion,
  orange,
  oranger: orange,
  orge: barley,
  origan: oregano,
  oseille: sorrel,
  panais: parsnip,
  papaye: papaya,
  papayer: papaya,
  pasteque: watermelon,
  "patate douce": sweetPotato,
  patisson,
  pavot: poppy,
  pecanier: pecan,
  pecher: peach,
  persil: parsley,
  "pe tsai": petsai,
  piment: chiliPepper,
  pissenlit: dandelion,
  pitaya: dragonFruit,
  plaquebiere: cloudberry,
  poire: pear,
  poireau: leek,
  poirier: pear,
  pois: peas,
  "pois a rames": peas,
  "pois chiche": chickpeas,
  "pois nain": peas,
  poivron,
  "pomme de terre": potatos,
  pommier: apple,
  potimarron: squash, // Generic
  potiron,
  radis: radish,
  "radis d'hiver": blackRadish,
  raifort: horseradish,
  rhubarbe: rhubarb,
  "rhubarbe commune": rhubarb,
  ribes: currant,
  romarin: rosemary,
  ronce: blackberry,
  "roquette cultivee": arugula,
  "roquette sauvage": arugula,
  roseau: reeds,
  sarriette: savory,
  sesame,
  soja: soybean,
  sorbier: rowan,
  sorgho: white,
  spermatophyte: seed,
  sureau: elderberry,
  "sureau noir": elderberry,
  tamarin: tamarind,
  tamarinier: tamarind,
  thym: thyme,
  tomate: tomato,
  tournesol: sunflower,
  vanille: vanilla,
  vigne: grape,
  viorne: viburnum,
  wasabi,
};

export const USAGE_ICONS: Record<string, string> = {
  vegetable: vegetables,
  flower,
  herb: rosemary,
  fruit: raspberry,
  green_manure: plant,
  cereal: barley,
  oilseed: olives,
  spice: cinnamon,
  textile: cotton,
};

export const METHOD_ICONS: Record<string, string> = {
  seeding_in_ground: seeding,
  seeding_inhouse: seedingGreenhouse,
  seeding_on_hot_bed: seedingSprout,
  plant: buyPlant,
  existing: plant2,
};

// Icons per agenda action id (20 = sow, 30 = plant, 41 = harvest, …). Sow/plant
// actions reuse the matching crop-method icon so the cycle timeline stays
// consistent with the method tiles; harvest/buy use dedicated icons.
export const ACTION_ICONS: Record<number, string> = {
  10: seedBag, // buy seeds
  11: buyPlant, // buy plants (= PLANT method)
  20: seedingGreenhouse, // sow warm / indoors (= SEEDING_INHOUSE method)
  21: seedingSprout, // sow on a hot bed (= SEEDING_ON_HOT_BED method)
  22: seeding, // sow in the ground (= SEEDING_IN_GROUND method)
  30: buyPlant, // plant (= PLANT method)
  40: vegetableGarden, // early harvest
  41: vegetableGarden, // harvest
  70: shovel, // divide
};

export function getUsageIcon(type: string): string | undefined {
  return USAGE_ICONS[type];
}

// Custom weather icons by OWM code prefix (see import above). Add entries as the
// icon set grows; unmapped codes fall back to the API's `icon_url`.
export const WEATHER_ICONS: Record<string, string> = {
  "01": weatherSun, // clear sky
  "02": weatherSunCloud, // few clouds
  "03": weatherCloud, // scattered clouds
  "04": weatherDarkCloud, // broken / overcast clouds
  "09": weatherRain, // shower rain
  "10": weatherRainyDay, // rain
  "11": weatherThunderstorm, // thunderstorm
  "13": weatherSnowfall, // snow
};

// Resolve a local weather icon from an OWM icon code (e.g. "01d" → sun), or null
// when there's no custom icon for it.
export function getWeatherIcon(owmCode: string | undefined | null): string | null {
  if (!owmCode) return null;
  return WEATHER_ICONS[owmCode.slice(0, 2)] ?? null;
}

export const leafIcon = leaf;

// Menu icons
export const seedBagIcon = seedBag;
export const shoppingCartIcon = shoppingCart;
export const shovelIcon = shovel;
export const flyingMoneyIcon = flyingMoney;
export const wheelbarrowIcon = wheelbarrow;
export const checkMarkIcon = checkMark;
export const daylightSavingTimeIcon = daylightSavingTime;
export const springCalendarIcon = springCalendar;
export const deadlineIcon = deadline;
export const growPlantIcon = growPlant;
export const harvestIcon = vegetableGarden;
export const actionPlanIcon = actionPlan;
export const blueprintIcon = blueprint;
export const puzzleIcon = puzzle;
export const magicWandIcon = magicWand;
export const sufficiencyIcon = sufficiency;
export const farmerMaleIcon = farmerMale;
export const farmerFemaleIcon = farmerFemale;
export const dnaIcon = dna;
export const sunshineIcon = sunshine;
export const sunriseIcon = sunrise;
export const waterDropIcon = waterDrop;
export const sprinklerIcon = sprinkler;
export const windIcon = wind;
export const humidityIcon = humidity;

// Garden plan
export const greenhouseIcon = greenhouse;
export const homeIcon = home;
export const raindropsIcon = raindrops;
export const pitchforkIcon = pitchfork;
export const grassIcon = grassPlan;
export const treeIcon = tree;
export const trunkIcon = trunk;
export const hedgeIcon = hedge;
export const crossIcon = cross;
export const footprintIcon = footprint;
export const crateIcon = crate;
